import React, { useEffect, useState } from 'react';
import VerificarPermisos from '../Tools/VerificarPermisos';
import MsgUtils from '../Tools/MsgUtils';
import addButton from '../../assets/addButon.png';
import { Document, Page, pdfjs } from 'react-pdf';
import '../css/Pdf.css';
import SinglePage from './SinglePage';
import ProtocoloContenido from './ProtocoloContenido';
import EncuestaRespond from '../Formularios/EncuestaRespond';
import HeaderExterno from '../HeaderExterno';
import ModalCargando from '../utilsComponentes/ModalCargando';

const server = process.env.REACT_APP_SERVER;
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function ProtocoloDirectoInicio() {
    const [vista, setVista] = useState(0);
    const [subVista, setSubVista] = useState(0);
    const [protocolos, setProtocolos] = useState([]);
    const [menuProtocolo, setMenuProtocolo] = useState([]);
    const [protocoloSelect, setProtocoloSelect] = useState({});
    const [selectMenu, setSelectMenu] = useState({});
    const [regional, setRegional] = useState(null);
    const [idEmpleado, setIdEmpleado] = useState(null);
    const [usuario, setUsuario] = useState({});
    const [actualizar, setActualizar] = useState(false);
    const [loader, setLoader] = useState(false);
    const [categorias, setCategorias] = useState([]);
    const [idCategoria, setIdCategoria] = useState(-1);

    // Formatea la fecha
    const formatoFecha = (fecha) => {
        let date = new Date(Date.parse(fecha));
        return `${date.getDate()}/${date.toLocaleString('default', { month: 'long' })}/${date.getFullYear()}`;
    };

    // Entrar a un protocolo
    const entrarProtocolo = (protocolo) => {
        setProtocoloSelect(protocolo);
        setMenuProtocolo(protocolo.MENU);
        setVista(1);
    };

     function cambioArea(valor){
        setIdCategoria(valor);
        getProtocolosActualizado(regional,valor);
    }

    function getProtocolosActualizado(reg,ida) {
          console.log('valores reg y valor', reg, ida);
            setProtocolos([]);
            setLoader(true);
          
            fetch(`${server}/protocolos/getProtocolos`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional:reg, idVersion: -1, idProtocolo: -1,idArea:ida
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        setProtocolos(data.ok);
                        console.log(protocolos);
                        //setVentana(0);
                    } else {
                        MsgUtils.msgError(data.error)
                    }
                    setLoader(false);
                })
                .catch(err => MsgUtils.msgError(err));
        }
    



    // Iconos según tipo de información
    function getImagen(dato) {
        switch (dato.TIPO_INFO) {
            case 'IMG': return "fa-solid fa-image";
            case 'IMGNS': return "fa-solid fa-images";
            case 'PDF': return "fa-solid fa-file-pdf";
            case 'DOC': return "fa-solid fa-file-word";
            case 'VID': return "fa-brands fa-youtube";
            case 'EXA': return "fa-solid fa-pen-clip";
            default: return "fa-solid fa-caret-down";
        }
    }

    // Mostrar contenido del protocolo
    const mostrarContenido = (dato) => {
        if (dato.TIPO_INFO !== 'EXA') {
            setSelectMenu({ ...dato, ...protocoloSelect });
            setSubVista(1);
        } else if (protocoloSelect.ID_ENCUESTA !== null) {
            setSubVista(3);
        }
    };

    // Salir de protocolos
    function salirProtocolos() {
        window.open('', '_parent', '');
        window.close();
    }

    // Obtener categorías
    function getCategoriaPro(reg) {
        fetch(`${server}/protocolos/getAreas`, {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ regional: reg })
        })
            .then(res => res.json())
            .then(data => {
                setLoader(false);
                
                if (data.ok){
                    setCategorias(data.ok);
                } 
                else MsgUtils.msgError(data.error);
            })
            .catch(err => MsgUtils.msgError(err));
    }

    // Buscar protocolos en la tabla
    function funcionBuscar() {
        const input = document.getElementById("buscadorPro");
        const filter = input.value.toUpperCase();
        const table = document.getElementById("protocolos");
        const tr = table.getElementsByTagName("tr");

        for (let i = 0; i < tr.length; i++) {
            const td = tr[i].getElementsByTagName("td")[1];
            if (td) {
                const txtValue = td.textContent || td.innerText;
                tr[i].style.display = txtValue.toUpperCase().includes(filter) ? "" : "none";
            }
        }
    }

    // Obtener protocolos
    function getProtocolos() {
        setLoader(true);
        fetch(`${server}/protocolos/getProtocolos`, {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ regional, idVersion: -1, idProtocolo: -1, idArea: -1 })
        })
            .then(res => res.json())
            .then(data => {
                setLoader(false);
                if (data.ok) setProtocolos(data.ok);
                else MsgUtils.msgError(data.error);
            })
            .catch(err => { setLoader(false); MsgUtils.msgError(err); });
    }

    // Cargar protocolos y categorías al inicio usando la URL
    useEffect(() => {
        if (vista !== 0) setVista(0);

        const dato = window.location.pathname.split('/');
        if (dato.length >= 4) {
            const reg = dato[2];
            const empleadoId = dato[3];

            localStorage.clear();
            setLoader(true);

            fetch(`${server}/protocolos/getProtocolos`, {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify({ regional: reg, idVersion: -1, idProtocolo: -1, idArea: -1 })
            })
                .then(res => res.json())
                .then(data => {
                    setLoader(false);
                    if (data.ok) {
                        setProtocolos(data.ok);
                        setRegional(reg);
                        setIdEmpleado(empleadoId);
                        setActualizar(prev => !prev);
                        getCategoriaPro(reg);
                    } else {
                        MsgUtils.msgError(data.error);
                    }
                })
                .catch(err => MsgUtils.msgError(err));
        }
    }, []);

    useEffect(() => { }, [usuario]);

    return (
        <div>
            {/* Header */}
            {regional != null && idEmpleado != null && (
                <HeaderExterno
                    regional={regional}
                    idEmpleado={idEmpleado}
                    titulo={"Protocolos"}
                    setUsuario={setUsuario}
                    actualizar={actualizar}
                    callback={salirProtocolos}
                />
            )}

            {/* Filtro y busqueda */}
            {vista === 0 && (
                <div className='container-fluid py-1'>
                    <div className='row row-cols g-1'>
                        <div className='col' style={{ maxWidth: '250px', minWidth: '200px' }}>
                            <div className='input-group'>
                                <label className='text-dark my-auto mx-2 fw-bold'>Departamento</label>
                                <select
                                    className="form-select form-select-sm btn-secondary"
                                    value={idCategoria}
                                    onChange={(e) => cambioArea(e.target.value)}
                                >
                                    <option value={-1}>TODOS</option>
                                {categorias.map((item, index) => {
                                    return (
                                        <option key={index} value={item.ID_CATEGORIA}>{item.CATEGORIA}</option>
                                    )
                                })}
                                </select>
                            </div>
                        </div>

                        <div className='col' style={{ maxWidth: '100px', minWidth: '100px' }}>
                            <button className='btn btn-sm btn-success w-100' onClick={getProtocolos}>
                                <i className="fa-solid fa-rotate-right"></i> Recargar
                            </button>
                        </div>

                        <div className='col' style={{ maxWidth: '250px', minWidth: '250px' }}>
                            <div className="input-group input-group-sm">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Buscar Protocolo"
                                    id='buscadorPro'
                                    onChange={funcionBuscar}
                                />
                                <button className='btn btn-sm btn-danger' onClick={() => { document.getElementById('buscadorPro').value = ''; funcionBuscar(); }}>
                                    <i className="fa-solid fa-circle-xmark"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Tabla de protocolos */}
            {vista === 0 && (
                <div className='table-responsive'>
                    <table className="table table-sm table-striped table-bordered border-secondary" id='protocolos'>
                        <caption>Lista de protocolos</caption>
                        <thead className='bg-secondary bg-gradient text-light fs-bold'>
                            <tr>
                                <th scope="col">DEPARTAMENTO</th>
                               
                                <th scope="col">FECHA</th>
                                <th scope="col">PROTOCOLO</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {protocolos.map((item, index) => {
                                
                                    return (
                                        <tr key={index} className='my-auto'>
                                            <th scope="row" className="col-1">
                                                <div className='container-fluid fw-bold'>
                                                    {item.AREA.split(':').map((valor, idx) => (
                                                        <div className='badge bg-light text-dark w-100' key={idx}>
                                                        {valor === '-Sin Clasificar-' ? 'Todos' : valor}
                                                        </div>
                                                    ))}
                                                    </div>
                                            </th>
                                            
                                            <td className='col-1'>{formatoFecha(new Date(item.FECHA))}</td>
                                            <td>{item.DESCRIPCION}</td>
                                            <td className='col-1 text-end'>
                                                <button className='btn btn-sm text-light btn-secondary' onClick={() => entrarProtocolo(item)}>
                                                    <i className="fa-solid fa-book-open-reader"></i> Leer
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                
                                return null;
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Vista de contenido */}
            {vista === 1 && (
                <div className='container-fluid'>
                    <div className='row row-cols-1 row-cols-sm-2 g-0'>
                        <div className='col col-sm-2 p-0 m-0'>
                            <ul className="list-group py-sm-4">
                                <div className='container-fluid text-center fw-bold' style={{ fontSize: "20px" }}>
                                    {protocoloSelect.DESCRIPCION}
                                </div>
                                {menuProtocolo.map((item, index) => {
                                    if (item.HAYSUBMENU === 0) {
                                        return (
                                            <li className="list-group-item bg-dark bg-gradient" key={index}>
                                                <button
                                                    className='btn btn-sm text-light fw-bold text-start w-100'
                                                    onClick={() => { setSubVista(-1); mostrarContenido(item); }}
                                                >
                                                    <i className={getImagen(item)}></i> {item.DESCRIPCION}
                                                </button>
                                            </li>
                                        );
                                    } else {
                                        return (
                                            <li className="list-group-item bg-dark bg-gradient" key={index}>
                                                <a
                                                    className="btn btn-sm w-100 text-light fw-bold text-start"
                                                    data-bs-toggle="collapse"
                                                    href={`#${item.DESCRIPCION}`}
                                                    role="button"
                                                    aria-expanded="false"
                                                    aria-controls="collapseExample"
                                                >
                                                    <i className={getImagen(item)}></i> {item.DESCRIPCION}
                                                </a>
                                                <div className="collapse" id={`${item.DESCRIPCION}`}>
                                                    <ul className="list-group">
                                                        {item.SUBMENU.map((subm, ind) => (
                                                            <li className="list-group-item bg-secondary bg-gradient m-0 p-0" key={ind}>
                                                                <button
                                                                    className='btn btn-sm text-light fw-bold text-start w-100'
                                                                    onClick={() => { setSubVista(-1); mostrarContenido(subm); }}
                                                                >
                                                                    <i className={getImagen(subm)}></i> {subm.DESCRIPCION}
                                                                </button>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </li>
                                        );
                                    }
                                })}
                                <li className='list-group-item bg-danger bg-gradient'>
                                    <button className='btn btn-sm text-light fw-bold text-start w-100' onClick={() => { setVista(0); setSubVista(0); }}>
                                        <i className="fa-solid fa-circle-xmark"></i> VOLVER A PROTOCOLOS
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <div className='col col-sm-10 px-sm-4 py-2 py-md-4'>
                            {subVista === 0 && <div className='fw-bold'>{"<== Elija un menu para ver el contenido"}</div>}
                            {subVista > 0 && subVista < 2 && <ProtocoloContenido info={selectMenu} regional={regional} subVista={subVista} />}
                            {subVista === 3 && <EncuestaRespond selectFormu={protocoloSelect} soloVer={false} teclado={true} />}
                        </div>
                    </div>
                </div>
            )}

            <ModalCargando show={loader} />
        </div>
    );
}

export default ProtocoloDirectoInicio;

